module.exports = __webpack_public_path__ + "media/images/weather/800_night-23282b85863693fe086506af663e82b9.png";